const graphicTextStyle = {
  fill: '#fff',
  backgroundColor: '#02516c',
  borderColor: '#056685',
  borderWidth: 1,
  borderRadius: 4,
  padding: [10, 10],
  font: '11px sans-serif',
  lineHeight: 16
};

const grid = {
  left: '60px',
  right: '40px',
  top: '50px',
  bottom: '40px'
};

// Keep the static industrial chart palette and axes in one place so the
// history page and the report renderer use the same visual language.
const industrialChartConfig = {
  backgroundColor: 'transparent',
  textStyle: {
    color: '#ffffff'
  },
  grid,
  xAxis: {
    type: 'category',
    axisLine: {
      lineStyle: {
        color: '#E5EEF5'
      }
    },
    axisLabel: {
      color: '#ffffff',
      fontSize: 12
    },
    splitLine: {
      lineStyle: {
        color: 'rgba(0, 212, 255, 0.2)',
        type: 'dashed'
      }
    }
  },
  tooltip: {
    trigger: 'axis',
    confine: true,
    backgroundColor: graphicTextStyle.backgroundColor,
    borderColor: graphicTextStyle.borderColor,
    borderWidth: graphicTextStyle.borderWidth,
    borderRadius: graphicTextStyle.borderRadius,
    padding: graphicTextStyle.padding,
    textStyle: {
      color: graphicTextStyle.fill,
      fontSize: 11,
      lineHeight: graphicTextStyle.lineHeight
    }
  },
  yAxis: {
    type: 'value',
    nameGap: 30,
    splitNumber: 4,
    nameTextStyle: {
      align: 'left',
      rich: {
        label: {
          color: '#ffffff',
          fontWeight: 'bold',
          fontSize: 16,
          padding: [0, 0, 0, -30]
        },
        unit: {
          color: '#fff',
          fontSize: 12
        }
      }
    },
    axisLabel: {
      color: '#ffffff'
    },
    splitLine: {
      lineStyle: {
        color: 'rgba(0, 212, 255, 0.2)',
        type: 'dashed'
      }
    }
  },
  legend: {
    top: 40,
    itemGap: 20,
    textStyle: {
      color: '#ffffff'
    }
  },
  toolbox: {
    show: true,
    feature: {
      dataZoom: {
        yAxisIndex: 'none',
        iconStyle: {
          opacity: 0
        }
      }
    }
  },
  series: {
    type: 'line',
    symbol: 'none',
    lineStyle: {
      width: 2,
      shadowBlur: 8
    }
  },
  seriesColors: ['#06ffa5', '#00d4ff', '#9d4edd', '#ff6b35', '#ffd23f', '#ff3366', '#9d4edd']
};

module.exports = {graphicTextStyle, grid, industrialChartConfig};
